@if (isPaymentsDuplicates || isPaymentsMixes) {
    <div class="mt-3 py-3 alert-container d-flex flex-grow-1 px-2 align-items-center">
        <mat-icon color="accent" class="material-symbols-outlined md-icon-24 alert-icon"> warning_amber </mat-icon>
        <div class="d-flex flex-column flex-grow-1">
            @if (isPaymentsDuplicates) {
                <div class="ms-2 flex-grow-1 alert-description mat-subtitle-1 m-0">
                    • To continue, please delete one duplicated item
                </div>
            }
            @if (isPaymentsMixes) {
                <div class="ms-2 flex-grow-1 alert-description mat-subtitle-1 m-0">
                    • To continue, please delete your MAWB or HAWB items
                </div>
            }
        </div>
    </div>
}
